import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiCheck, FiArrowLeft } = FiIcons;

const FeatureSplitSection = () => {
  return (
    <section className="feature-split-section section bg-white">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            טפסי דיאלוג חכמים (במקום טפסים סטטיים)
          </h2>
        </motion.div>
        
        <div className="comparison-grid grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
          <motion.div
            className="before-column bg-red-50 p-8 rounded-2xl border-2 border-red-200"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-red-700 mb-6 text-center">לפני</h3>
            <div className="space-y-4">
              {[
                "טופס ארוך → נטישה",
                "מידע חסר", 
                "שיחות סרק"
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <SafeIcon icon={FiX} className="text-red-500 flex-shrink-0" />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </motion.div>
          
          <motion.div
            className="arrow-column flex justify-center"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <div className="bg-purple-100 p-6 rounded-full">
              <SafeIcon icon={FiArrowLeft} className="text-4xl text-purple-600" />
            </div>
          </motion.div>
          
          <motion.div
            className="after-column bg-green-50 p-8 rounded-2xl border-2 border-green-200"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl font-bold text-green-700 mb-6 text-center">עם Botley</h3>
            <div className="space-y-4 mb-6">
              {[
                "שואל את השאלה הנכונה בזמן הנכון",
                "מברר צדדים/עילות/מועדים/מסמכים נלווים",
                "מסווג לאיש מקצוע מתאים ומציע קביעת שיחה – הכל באינטראקציה נעימה"
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <SafeIcon icon={FiCheck} className="text-green-500 flex-shrink-0" />
                  <span className="text-gray-700 text-sm">{item}</span>
                </div>
              ))}
            </div>
            <div className="bg-green-100 p-4 rounded-xl">
              <p className="text-green-800 font-semibold text-sm">
                תוצאה: עד פי 3 יותר לידים + איכות טובה יותר לפתיחת תיק.
              </p>
            </div>
          </motion.div>
        </div>
        
        <motion.div
          className="stats-highlight flex flex-col sm:flex-row justify-center gap-8 mt-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
        >
          <div className="stat-item text-center">
            <div className="text-4xl font-bold text-purple-600 mb-2">30%+</div>
            <div className="text-gray-600">עלייה בערך הלידים</div>
          </div>
          <div className="stat-item text-center">
            <div className="text-4xl font-bold text-purple-600 mb-2">×3</div>
            <div className="text-gray-600">יותר לידים לעומת טפסים מסורתיים</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FeatureSplitSection;